export const RESPONDENT_ALREADY_INVITED = 'Respondent already invited.';
